import React, { useEffect, useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import BestProducts from "../components/common/products/BestProducts";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import { httpReauest } from "../utils/httpRequest";
import { useParams } from "react-router-dom";
import { CDN_BASE_URL } from "../config";
import { Helmet } from "react-helmet";
import PathShow from "../components/layout/PathShow";
import ProductsCard from "../components/common/card/ProductsCard";
import ProductCardMobile from "../components/common/mobile/ProductCardMobile";
import Loading from "../components/common/Loading";

const BrandsDetailPageCategory = () => {
  const { brand, category } = useParams();

  const [loading, setLoading] = useState();

  const [selectedBrand, setselectedBrand] = useState();
  const [selectedCategory, setselectedCategory] = useState();
  const [vehicles, setvehicles] = useState();

  const url = `https://1924.ir/${category}/${brand}`;

  useEffect(() => {
    getData();
  }, [category, brand]);

  async function getData() {
    setLoading(true);
    await httpReauest(
      "GET",
      `/vehicle/details/${category}/${brand}`,
      {},
      {}
    ).then(({ data }) => {
      setselectedBrand(data?.data.brand);
      setselectedCategory(data?.data.category);
      setvehicles(data?.data.vehicles);
    });
    setLoading(false);
  }

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="container_1 py-8">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {category == "light-truck"
            ? selectedBrand?.meta_title_lighttruck
            : category == "truck"
            ? selectedBrand?.meta_title_truck
            : category == "heavy-truck"
            ? selectedBrand?.meta_title_heavytruck
            : category == "truck-accessories-equipment"
            ? selectedBrand?.meta_title_accessories
            : category == "road-construction-machines"
            ? selectedBrand?.meta_title_roadconstruction
            : selectedBrand.title}
        </title>
        <meta
          name="description"
          content={
            category == "light-truck"
              ? selectedBrand?.meta_desc_lighttruck
              : category == "truck"
              ? selectedBrand?.meta_desc_truck
              : category == "heavy-truck"
              ? selectedBrand?.meta_desc_heavytruck
              : category == "truck-accessories-equipment"
              ? selectedBrand?.meta_desc_accessories
              : category == "road-construction-machines"
              ? selectedBrand?.meta_desc_roadconstruction
              : selectedBrand.desc
          }
        />
        <meta name="keywords" content={""} />
        <meta
          name="og:description"
          content={
            category == "light-truck"
              ? selectedBrand?.meta_desc_lighttruck
              : category == "truck"
              ? selectedBrand?.meta_desc_truck
              : category == "heavy-truck"
              ? selectedBrand?.meta_desc_heavytruck
              : category == "truck-accessories-equipment"
              ? selectedBrand?.meta_desc_accessories
              : category == "road-construction-machines"
              ? selectedBrand?.meta_desc_roadconstruction
              : selectedBrand.desc
          }
        />
        <meta
          name="og:title"
          content={
            category == "light-truck"
              ? selectedBrand?.meta_title_lighttruck
              : category == "truck"
              ? selectedBrand?.meta_title_truck
              : category == "heavy-truck"
              ? selectedBrand?.meta_title_heavytruck
              : category == "truck-accessories-equipment"
              ? selectedBrand?.meta_title_accessories
              : category == "road-construction-machines"
              ? selectedBrand?.meta_title_roadconstruction
              : selectedBrand.title
          }
        />
        <link rel="canonical" href={url} />
      </Helmet>{" "}
      <div className="relative mb-12">
        <PathShow
          category={selectedCategory?.name}
          brand={selectedBrand?.title}
          categoryId={category}
          brandId={selectedBrand?.name}
        />
        <img
          src={
            CDN_BASE_URL + category == "light-truck"
              ? selectedBrand?.cover_lighttruck
              : category == "truck"
              ? selectedBrand?.cover_truck
              : category == "heavy-truck"
              ? selectedBrand?.cover_heavytruck
              : category == "truck-accessories-equipment"
              ? selectedBrand?.cover_accessories
              : selectedBrand?.cover
          }
          className="w-full my-5 lg:my-10 rounded-[10px] center"
          alt=""
        />
        <span className="absolute bg-white rounded-full w-[65px]  h-[65px]  lg:w-[95px] lg:h-[95px] -bottom-8 lg:-bottom-11 border-2 border-black left-[50%] translate-x-[-50%] overflow-hidden">
          <img
            className="w-full h-full object-cover rounded-full"
            alt="brand"
            src={CDN_BASE_URL + selectedBrand?.logo}
          />
        </span>
      </div>
      <div className="pt-12 lg:grid hidden lg:grid-cols-4 gap-4">
        {vehicles?.map((item) => (
          <ProductsCard data={item} />
        ))}
        {/* {selectedBrand && <BestProducts brand={selectedBrand?._id} />} */}
      </div>{" "}
      <div className="my-6 grid lg:hidden ">
        {vehicles?.map((item) => (
          <ProductCardMobile data={item} />
        ))}
        {/* {selectedBrand && <BestProducts brand={selectedBrand?._id} />} */}
      </div>
      <div className="lg:my-16">
        <h1 className="title">{selectedBrand?.title}</h1>
        <div
          className="desc_details overflow-x-scroll"
          dangerouslySetInnerHTML={{
            __html:
              category == "light-truck"
                ? selectedBrand?.desc_lighttruck
                : category == "truck"
                ? selectedBrand?.desc_truck
                : category == "heavy-truck"
                ? selectedBrand?.desc_heavytruck
                : category == "truck-accessories-equipment"
                ? selectedBrand?.desc_accessories
                : selectedBrand?.desc,
          }}
        />
      </div>
     
      <div className="pt-6 hidden lg:block">
        <RequestGetList />
      </div>
    </div>
  );
};

export default BrandsDetailPageCategory;
